import { Component, OnInit } from '@angular/core';
export class MainToolbarMenuItemComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[hd-left-menu-item]',
  template: `
    <ng-content></ng-content>
  `,
  styles: [`
    @media (min-width: 993px) {
      :host {
        position: relative;
        padding: 0px 20px;
        height: 100%;
        display: table-cell;
        vertical-align: middle;
        padding: 0px 20px; } }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MainToolbarMenuItemComponent_tsickle_Closure_declarations() {
/** @type {?} */
MainToolbarMenuItemComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MainToolbarMenuItemComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
